import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Row, Col } from 'antd';
import BillModelData from '../ModelData';
import Item from 'antd/lib/list/Item';

const { paymentMeans } = BillModelData;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const documentInfo = this.modulesState.documentInfo;
        return (
            <div>
                <Row>
                    
                    <Col span={5}>
                        <span className={css.titleName}>支付方式</span>
                    </Col>
                    <Col span={19}>
                        <div className={css.info}>{ paymentMeans[documentInfo.PaymentMeans]}</div>
                    </Col>
                </Row>
                <Row>
                    <Col span={5}>
                        <span className={css.titleName}>收货地址</span>
                    </Col>
                    <Col span={19}>
                        <div className={css.info}>
                            <div>
                                {this.getCountry(documentInfo.DeliveryAddress.Country)}&nbsp;&nbsp;
                                {/* {documentInfo.DeliveryAddress.Country} */}
                                {documentInfo.DeliveryAddress.CountrySubentity}&nbsp;&nbsp;
                                {documentInfo.DeliveryAddress.CityName}&nbsp;&nbsp;
                                {documentInfo.DeliveryAddress.AddressLine}&nbsp;&nbsp;
                            </div>
                            <div>{documentInfo.DeliveryContact.Name && `${documentInfo.DeliveryContact.Name} | `}{documentInfo.DeliveryContact.Phone}</div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
    // 国家code转换
    private getCountry = (code: string) => {
        let data = this.modulesState.countryList.filter((item) => {
            return item.code === code;
        });
        return data[0] && data[0].name ? data[0].name : code;
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentDetail/UI.OrderAddition.tsx